Directives.SearchEventDirective =  function SearchEventDirective(){

    // @ngInject
    function SearchEventDirectiveControllerFunc($scope, $injector, AnalyticsService, $state, AppStates){

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SearchEventDirectiveController';
        this.AppStates = AppStates;

        this.goToEvent = function goToEvent ($event){
            $event.preventDefault();

            $state.go(AppStates.root_core_navigation_event_overview, {event_id: this.searchResult.event_id});

            AnalyticsService.track(this, AnalyticsService.analytics_events.search_result_item_clicked,
                {searched_id: this.eventId,
                 searched_type: 'Event'});

        };
    }

    var SearchEventDirectiveController = Class(Controllers.BaseController, {
        constructor: SearchEventDirectiveControllerFunc
    });

    return {
        scope:{
            searchResult: "=searchResult",
            searchPhrase: '@searchPhrase',
            loaderOnClick: "=?"
        },
        templateUrl : 'angular/app/modules/core/features/search/event/search_event_directive_template.html',
        controller : SearchEventDirectiveController,
        controllerAs : 'searchEventVm',
        bindToController : true

    };
};
